<template lang="pug">
  .jxhh-main
    .header
      .img
        img(src="@assets/jxhh/1.png")
      .text-contain
        .btns
          a(target="_blank" :href="appleUrl" @click="aclick(1)")
            .btn 下载IOS版 >
              .qrcode 
                div APP正在内测阶段，近期将会与用户见面哟~
          a(target="_blank" v-bind:href="apkUrl" @click="aclick(2)")
            .btn.android 下载安卓版 >
              .qrcode 
                div APP正在内测阶段，近期将会与用户见面哟~
    .common
      .img
        img(src="@assets/jxhh/2.png")
    .common
      .img
        img(src="@assets/jxhh/3.png")
    .common
      .img
        img(src="@assets/jxhh/4.png")
    .footer
      .right Copyright © 2008-2018 vip.com，All Rights Reserved
      .beian
        a(href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010302111111" target="_blank") 粤公网安备 44010302111111号
        a(href="https://beian.miit.gov.cn/" target="_blank")  粤ICP备08114786号
</template>

<script>

export default {
  name: 'jxhh',
  data () {
    return {
    }
  },
  methods: {
    aclick() {
    }
  },
  created() {
    document.title = '精选好货'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.jxhh-main
  max-width 1920px
  min-width 1280px
  margin auto
  font-size 0
  a,&:link, &:active, &:active,&:visited
    text-decoration none
    color inherit
  img
    width 100%
    height auto
  .header
    .text-contain
      font-size 72px
      color #fff
      line-height 90px
      position absolute
      left 12%
      top 27%
      width 500px
      .btns
        position absolute
        .btn:hover
          .qrcode
            display block
        .btn
          background rgb(237,0,50)
          color #fff
          text-align center
          padding 0 15px
          height 65px
          font-size 28px
          font-weight normal
          font-stretch normal
          line-height 65px
          letter-spacing 0
          display inline-block
          vertical-align top
          margin 20px
          .qrcode
            position absolute
            display none
            background #fff
            width 230px
            height 230px
            top 80px
            left -400px
            right -400px
            margin auto
            div
              width 100%
              height 100%
              color red
              font-size 28px
              line-height 50px
              img
                width 100% !important
                height 100% !important
            &::before
              position absolute
              top -20px
              left 0
              right 0
              margin auto
              content ' '
              display block
              width 0
              height 0
              border 10px solid transparent
              border-bottom-color #fff
  .footer
    padding 20px 0
    background #ccc
    font-size 12px
    line-height 24px
    text-align center
    color #565656

</style>



// WEBPACK FOOTER //
// src/views/JXHH.vue